import { useState, useEffect } from 'react';
import { countdown } from '../utils';

export default function CountdownTimer({ finishesAt }) {
  const [text, setText] = useState(() => countdown(finishesAt));

  useEffect(() => {
    const id = setInterval(() => setText(countdown(finishesAt)), 1000);
    return () => clearInterval(id);
  }, [finishesAt]);

  return <span className="countdown">{text}</span>;
}
